<template>
  <div class="upload_box">
    <!-- 视频发布上传 -->
    <div class="video_apply_box_upload">
      <el-upload
        class="lf"
        action="FSK"
        accept = '.mp4'
        :show-file-list = 'false'
        :disabled="btnOnOff"
        :http-request="videoUpload">
        <el-button type="primary" >点击上传</el-button>
        <div slot="tip" class="el-upload__tip">视频上传大小不能超过 3G！</div>
      </el-upload>
      <div v-show="progressOnOff" class="video_apply_progress_box lf">
        <div class="video_apply_progress_title">{{title}}</div>
        <div class="video_apply_progress_container lf">
          <el-progress :percentage="progress" color="#d7b76d"></el-progress>
        </div>
        <div class="video_apply_progress_btn rt">
          <el-button v-show="!delOnOff" size="mini" @click="cancel()">取消</el-button>
          <el-button v-show="delOnOff" size="mini" @click="delUpload()">删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
export default {
  name: 'videoUpload',
  props: {
    videotype: { // 文件类型
      type: String,
      required: true
    },
    videourl: {
      type: String
    }
  },
  data () {
    return {
      btnOnOff: false, // 控制按钮开关
      progressOnOff: false, // 是否显示上传进度
      progress: 0, // 视频上传进度
      delOnOff: false, // 是否显示删除按钮
      cancel: null, // 取消视频上传函数
      title: '', // 上传视频标题
      fieldId: '', // 视频id
      url: '' // 视频地址
    }
  },
  created () {
    // this.videourl = this.videourl // 获取视频地址
  },
  methods: {
    // 获取签名  这里的签名请求是由后端提供的，只需要拿到后端给的签名请求即可
    getVodSignature () {
      return this.myApi.getVideoSig().then(function (response) {
        return response.data.data
      })
    },
    // 重置视频上传显示
    resetVideo () {
      this.progressOnOff = false // 关闭视频进度条显示
      this.progress = 0 // 视频进度条归零
      this.delOnOff = false // 视频删除按钮隐藏，取消显示
      this.title = '' // 视频文件名字清空
    },
    // 删除上传视频
    delUpload () {
      const vueThat = this
      this.$confirm('此操作将删除该文件,文件删除后不可恢复，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.delVideoRecord({ field_id: vueThat.fieldId }).then((res) => {
          vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
          if (res.data.code === 200) {
            vueThat.$message({
              message: '删除成功！',
              type: 'success'
            })
            vueThat.resetVideo()
          }
        })
      }).catch(() => {})
    },
    // 上传视频接口
    videoUpload (param) {
      const vueThat = this
      vueThat.btnOnOff = true // 视频选中后，禁止使用上传按钮
      vueThat.title = param.file.name
      vueThat.progressOnOff = true
      // 必须以函数的形式返回  sdk参数限制
      const getSignature = async () => {
        const data = await this.getVodSignature()
        return data
      }
      const tcVod = new TcVod({
        getSignature: getSignature // 获取上传签名的函数
      })
      const uploader = tcVod.upload({
        mediaFile: param.file // 媒体文件（视频或音频或图片），类型为 File
      })
      // 视频上传进度
      uploader.on('media_progress', function (info) {
        const progress = parseInt(info.percent * 100)
        if (progress < 100) {
          vueThat.progress = progress
        } else {
          vueThat.progress = 99
        }
      })
      // 视频上传
      uploader.done().then(function (info) {
        // 上传成功
        vueThat.myApi.addVideoRecord({ field_id: info.fileId }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              type: 'success',
              message: '上传成功!'
            })
            vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
            vueThat.progress = 100
            vueThat.delOnOff = true
            vueThat.fieldId = info.fileId
            vueThat.url = info.video.url
            vueThat.$emit('files', vueThat.fieldId, vueThat.url)
          } else {
            vueThat.$message({
              type: 'success',
              message: '上传失败!'
            })
            vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
          }
        }).catch(() => {
          // 上传失败
          vueThat.$message({
            type: 'success',
            message: '上传失败!'
          })
          vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
        })
      }).catch(function () {
        vueThat.$message({
          type: 'success',
          message: '上传失败!'
        })
        vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
      })
      // 取消视频上传
      vueThat.cancel = () => {
        vueThat.$confirm('此操作将取消上传, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vueThat.$message({
            type: 'success',
            message: '已取消上传!'
          })
          vueThat.btnOnOff = false // 视频选中后，禁止使用上传按钮
          uploader.cancel()
          vueThat.resetVideo()
        }).catch(() => {})
      }
    }
  }
}
</script>

<style>
</style>
